import { getContext } from '@/context';

const getAccessToken = () => {
  const headers = getContext().utils.api.getHeaders();
  const authHeader = headers?.Authorization;

  if (!authHeader) {
    return '';
  }

  return authHeader.replace(/^Bearer\s+/i, '');
};

export { getAccessToken };
